export default __webpack_public_path__ + "static/media/d5c2455d5a7ee14fe32d583081ece7cb.0e222033.svg";